import comp from "./ConfirmationModal";
export default comp;
